import { AbstractControl } from '@angular/forms';

export function ValidateGreaterThanZero(control: AbstractControl) {
  if (control.value && control.value <= 0) {
    return {smaller: true}
  }
  return null;
}
